import React from "react";
import settingsIcon from "../../assets/icons/sidebarIcons/settingsIcon.svg";
import logOutIcon from "../../assets/icons/sidebarIcons/logOutIcon.svg";
import profileImage from "../../assets/images/profileImage.png";
const SidebarFooter = () => {
  return (
    <div className="w-[85%] mx-auto absolute bottom-[5%] text-white">
      <div className="bg-[#34BD5A] flex items-center justify-between flex-wrap rounded-[12px] px-[10px] py-[12px] cursor-pointer">
        <div className="flex items-center">
          <img className="w-[24px] h-[24px] " src={profileImage} alt="logo" />
          <p className="pl-[5px]">John Philipp</p>
        </div>
        <div>
          <img src={settingsIcon} alt="logo" />
        </div>
      </div>
      <div className=" flex items-center justify-between flex-wrap bg-[#12283B] mt-2 rounded-[12px] px-[10px] py-[12px] cursor-pointer">
        <img src={logOutIcon} alt="arrow" />
        <p>Log Out</p>
      </div>
    </div>
  );
};

export default SidebarFooter;
